export enum EmptyTimelineVariant {
	Upcoming = "upcoming",
	Recent = "recent",
}
